var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":`rotate${_vm.is_counter_clockwise ? '-counter-clockwise' : ''}`}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }